import {Action} from '@ngrx/store';
import {Aufgabe, Checkliste, Dokument, Rolle, VeranstaltungDetail} from '../../../clients/veranstaltungen';
import {PandemieLevel} from '../../../clients/pandemie';
import {Benutzer} from '../../../clients/vorlagen';

export const PAGE_STATE_RESET = '[VeranstaltungenPage] Page State reset';
export const VERANSTALTUNG_DETAIL_RESET = '[VeranstaltungenPage] Veranstaltung Detail reset';
export const IGNORE_WS_ACTION = '[VeranstaltungenPage] WS Action ignoriert';

export const NICHT_ANZUZEIGENDE_ROLLEN_BENUTZER_SETZEN = '[VeranstaltungenPage] Benutzer die aus der Auswahl entfernt werden sollen setzen';
export const ROLLE_SETZEN = '[VeranstaltungenPage] Rolle setzen';
export const ROLLEN_BENUTZER_SETZEN = '[VeranstaltungenPage] Selektierte Benutzer Ids setzen';

export const NEUE_VERANSTALTUNG = '[VeranstaltungenPage] Neue Veranstaltung';
export const NEUE_VERANSTALTUNG_ABBRECHEN = '[VeranstaltungenPage] Neue Veranstaltung abbrechen';
export const NEUE_VERANSTALTUNG_DETAIL_SETZEN = '[VeranstaltungenPage] Neue Veranstaltung Detail Setzen';
export const FUNKTIONSBEREICH_CHECKLISTE_SETZEN = '[VeranstaltungenPage] Funktionsbereich Checkliste setzen';

export const SETZE_VERANSTALTUNG_FELD = '[VeranstaltungenPage] Ändere Veranstaltungsfeld';
export const SETZE_VERANSTALTUNG_TITEL = '[VeranstaltungenPage] Ändere Veranstaltungstitel';
export const SETZE_VERANSTALTUNG_BEGINN = '[VeranstaltungenPage] Ändere Veranstaltungsbeginn';
export const SETZE_VERANSTALTUNG_EINLASS = '[VeranstaltungenPage] Ändere Veranstaltungseinlass';
export const SETZE_VERANSTALTUNG_SAISON = '[VeranstaltungenPage] Ändere Veranstaltungssaison';
export const SETZE_VERANSTALTUNG_VERANSTALTUNGSLEITER = '[VeranstaltungenPage] Ändere Veranstaltungsleiter';
export const SETZE_VERANSTALTUNG_VERANSTALTUNGSBEOBACHTER = '[VeranstaltungenPage] Ändere Veranstaltungsbeobachter';

export const TOGGEL_FUNKTIONSBEREICH_CHECKLISTEN_ACTION = '[VeranstaltungenPage] Toggle Funktionsbereich Checklisten';

export const TOGGEL_AUFGABEN_ACTION = '[VeranstaltungenPage] Toggle Aufgaben';

export const AUFGABE_SETZEN = '[VeranstaltungenPage] Aufgabe setzen';

export const DOKUMENT_SELECTED_SETZEN = '[VeranstaltungenPage] Selektiertes Dokument setzen';
export const DOKUMENT_UPLOAD_SETZEN = '[VeranstaltungenPage] Dokument upload setzen';
export const DOKUMENT_ID_SETZEN = '[VeranstaltungenPage] Dokument id setzen';
export const AKTUELLES_DOKUMENT_AENDERN = '[VeranstaltungenPage] Aktuelles Dokument wurde in der Ansicht geändert';
export const DOKUMENT_LESE_BERECHTIGUNGEN_SELECTED_SETZEN = '[VeranstaltungenPage] Selektierte Leseberechtigungen Dokument setzen';
export const DOKUMENT_BEARBEITEN_BERECHTIGUNGEN_SELECTED_SETZEN = '[VeranstaltungenPage] Selektierte Bearbeitenberechtigungen Dokument setzen';
export const DOKUMENT_LESE_BERECHTIGUNGEN_ENTFERNEN = '[VeranstaltungenPage] Selektierte Leseberechtigungen entfernen';
export const DOKUMENT_BEARBEITEN_BERECHTIGUNGEN_ENTFERNEN = '[VeranstaltungenPage] Selektierte Bearbeitenberechtigungen entfernen';

export const SETZE_VERANSTALTUNG_STICHTAG_PANDEMIE_LEVEL = '[VeranstaltungenPage] Ändere Stichtag der Pandemie-Level-Berechnung';
export const PANDEMIE_LEVEL_ABFRAGEN = '[VeranstaltungenPage] Pandemie-Level abfragen';
export const SETZE_PANDEMIE_LEVEL_UI = '[VeranstaltungenPage] Pandemie-Level in der Ui setzen';
export const PANDEMIE_LEVEL_EINSTELLEN = '[VeranstaltungenPage] Pandemie-Level einstellen';

export const FUNKTIONSBEREICH_SETZEN = '[VeranstaltungenPage] Funktionsbereich in Aufgaben Berechtigungen ausgewählt';
export const SET_SELECTED_AUFGABEN = '[VeranstaltungenPage] Set selected Aufgaben';
export const BENUTZER_BERECHTIGUNGEN_HINZUFUEGEN = '[VeranstaltungenPage] Benutzerberechtigungen hinzufügen';
export const BENUTZER_BERECHTIGUNGEN_ENTFERNEN = '[VeranstaltungenPage] Benutzerberechtigungen entfernen';



// PAGE STATE RESET
export class PageStateResetAction implements Action {
    readonly type = PAGE_STATE_RESET;
}

// VERANSTALTUNG DETAIL RESET
export class VeranstaltungDetailResetAction implements Action {
    readonly type = VERANSTALTUNG_DETAIL_RESET;
}

// IGNORE WS ACTION
export class IgnoreWSAction implements Action {
    readonly type = IGNORE_WS_ACTION;

    constructor(public payload: any) {
    }
}

// BENUTZER
export class NichtAnzuzeigendeRollenBenutzerSetzenAction implements Action {
    readonly type = NICHT_ANZUZEIGENDE_ROLLEN_BENUTZER_SETZEN;

    constructor(public nichtAnzuzeigendeBenutzer: Array<any>) {
    }
}

export class RolleSetzenAction implements Action {
    readonly type = ROLLE_SETZEN;

    constructor(public rolle: Rolle) {
    }
}

export class RollenBenutzerSetzenAction implements Action {
    readonly type = ROLLEN_BENUTZER_SETZEN;

    constructor(public payload: Array<string>) {
    }
}


// VERANSTALTUNGEN

export class NeueVeranstaltungAction implements Action {
    readonly type = NEUE_VERANSTALTUNG;

    constructor() {
    }
}

export class NeueVeranstaltungAbbrechenAction implements Action {
    readonly type = NEUE_VERANSTALTUNG_ABBRECHEN;

    constructor() {
    }
}

export class NeueVeranstaltungDetailSetzenAction implements Action {
    readonly type = NEUE_VERANSTALTUNG_DETAIL_SETZEN;

    constructor(public detail: VeranstaltungDetail) {
    }
}

export class SetzeVeranstaltungFeldAction implements Action {
    readonly type = SETZE_VERANSTALTUNG_FELD;

    constructor(public key: string, public wert: string) {
    }
}

export class SetzeVeranstaltungTitelAction implements Action {
    readonly type = SETZE_VERANSTALTUNG_TITEL;

    constructor(public titel: string) {
    }
}

export class SetzeVeranstaltungBeginnAction implements Action {
    readonly type = SETZE_VERANSTALTUNG_BEGINN;

    constructor(public beginn: Date) {
    }
}

export class SetzeVeranstaltungEinlassAction implements Action {
    readonly type = SETZE_VERANSTALTUNG_EINLASS;

    constructor(public einlass: Date) {
    }
}

export class SetzeVeranstaltungSaisonAction implements Action {
    readonly type = SETZE_VERANSTALTUNG_SAISON;

    constructor(public saison_id: string) {
    }
}

export class SetzeVeranstaltungVeranstaltungsleiterAction implements Action {
    readonly type = SETZE_VERANSTALTUNG_VERANSTALTUNGSLEITER;

    constructor(public payload: string) {
    }
}

export class SetzeVeranstaltungVeranstaltungsbeobachterAction implements Action {
    readonly type = SETZE_VERANSTALTUNG_VERANSTALTUNGSBEOBACHTER;

    constructor(public payload: string) {
    }
}

// FUNKTIONSBEREICHE CHECKLISTEN
export class FunktionsbereichChecklisteSetzenAction implements Action {
    readonly type = FUNKTIONSBEREICH_CHECKLISTE_SETZEN;

    constructor(public checkliste: Checkliste) {
    }
}

export class ToggleFunktionsbereichChecklistenAction implements Action {
    readonly type = TOGGEL_FUNKTIONSBEREICH_CHECKLISTEN_ACTION;

    constructor(public funktionsbereichId: string) {
    }
}

export class ToggleAufgabenAction implements Action {
    readonly type = TOGGEL_AUFGABEN_ACTION;

    constructor(public checklisteId: string) {
    }
}

export class AufgabeSetzenAction implements Action {
    readonly type = AUFGABE_SETZEN;

    constructor(public aufgabe: Aufgabe) {}
}

export class DokumentSelectedSetzenAction implements Action {
    readonly type = DOKUMENT_SELECTED_SETZEN;

    constructor(public payload: Dokument) {}
}

export class DokumentUploadSetzenAction implements Action {
    readonly type = DOKUMENT_UPLOAD_SETZEN;

    constructor(public uploadId: string, public dateiname: string) {
    }
}

export class DokumentIdSetzenAction implements Action {
    readonly type = DOKUMENT_ID_SETZEN;

    constructor(public id: string) {
    }
}

export class AktuellesDokumentAendernAction implements Action {
    readonly type = AKTUELLES_DOKUMENT_AENDERN;

    constructor(public dokument?: Dokument) {
    }
}

export class DokumentLeseBerechtigungenSelectedSetzenAction implements Action {
    readonly type = DOKUMENT_LESE_BERECHTIGUNGEN_SELECTED_SETZEN;

    constructor(public payload: Array<string>) {}
}

export class DokumentBearbeitenBerechtigungenSelectedSetzenAction implements Action {
    readonly type = DOKUMENT_BEARBEITEN_BERECHTIGUNGEN_SELECTED_SETZEN;

    constructor(public payload: Array<string>) {}
}

export class DokumentLeseBerechtigungenEntfernenAction implements Action {
    readonly type = DOKUMENT_LESE_BERECHTIGUNGEN_ENTFERNEN;

    constructor() {
    }
}

export class DokumentBearbeitenBerechtigungenEntfernenAction implements Action {
    readonly type = DOKUMENT_BEARBEITEN_BERECHTIGUNGEN_ENTFERNEN;

    constructor() {
    }
}

export class SetzeVeranstaltungStichtagPandemieLevelAction implements Action {
    readonly type = SETZE_VERANSTALTUNG_STICHTAG_PANDEMIE_LEVEL;

    constructor(public stichtag: Date) {
    }
}

export class PandemieLevelAbfrageAction implements Action {
    readonly type = PANDEMIE_LEVEL_ABFRAGEN;

    constructor() {
    }
}

export class SetzePandemieLevelUiAction implements Action {
    readonly type = SETZE_PANDEMIE_LEVEL_UI;

    constructor(public level: PandemieLevel) {
    }
}

export class PandemieLevelEinstellenAction implements Action {
    readonly type = PANDEMIE_LEVEL_EINSTELLEN;

    constructor() {
    }
}

export class FunktionsbereichSetzenAction implements Action {
    readonly type = FUNKTIONSBEREICH_SETZEN;

    constructor(public fbId: string) {
    }
}

export class SetSelectedAufgabenAction implements Action {
    readonly type = SET_SELECTED_AUFGABEN;

    constructor(public payload: Array<string>) {
    }
}

export class BenutzerberechtigungenHinzufuegenAction implements Action {
    readonly type = BENUTZER_BERECHTIGUNGEN_HINZUFUEGEN;

    constructor(public payload: Array<string>) {
    }
}

export class BenutzerberechtigungenEntfernenAction implements Action {
    readonly type = BENUTZER_BERECHTIGUNGEN_ENTFERNEN;

    constructor(public payload: Benutzer) {
    }
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions =
    NichtAnzuzeigendeRollenBenutzerSetzenAction
    | RolleSetzenAction
    | NeueVeranstaltungAction
    | NeueVeranstaltungAbbrechenAction
    | NeueVeranstaltungDetailSetzenAction
    | SetzeVeranstaltungFeldAction
    | SetzeVeranstaltungTitelAction
    | SetzeVeranstaltungEinlassAction
    | SetzeVeranstaltungBeginnAction
    | SetzeVeranstaltungSaisonAction
    | PageStateResetAction
    | IgnoreWSAction
    | SetzeVeranstaltungVeranstaltungsleiterAction
    | SetzeVeranstaltungVeranstaltungsbeobachterAction
    | ToggleFunktionsbereichChecklistenAction
    | ToggleAufgabenAction
    | AufgabeSetzenAction
    | DokumentSelectedSetzenAction
    | AktuellesDokumentAendernAction
    | DokumentUploadSetzenAction
    | DokumentIdSetzenAction
    | DokumentLeseBerechtigungenSelectedSetzenAction
    | DokumentBearbeitenBerechtigungenSelectedSetzenAction
    | DokumentLeseBerechtigungenEntfernenAction
    | DokumentBearbeitenBerechtigungenEntfernenAction
    | SetzeVeranstaltungStichtagPandemieLevelAction
    | PandemieLevelAbfrageAction
    | SetzePandemieLevelUiAction
    | PandemieLevelEinstellenAction
    | FunktionsbereichSetzenAction
    | SetSelectedAufgabenAction
    | BenutzerberechtigungenHinzufuegenAction
    | BenutzerberechtigungenEntfernenAction
    ;
